var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{attrs:{"subhead":false}},[_c('div',{staticClass:"mx-auto",attrs:{"id":"formContent"}},[_c('SaveSpinner',{attrs:{"loadFlag":_vm.ui.loadingflag}}),(_vm.invalid)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.$t('invalidlogin')))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }